import React from "react";
import { HeroSection } from "../components/sections/HeroSection";
import { StorySection } from "../components/sections/StorySection";
import { MasterMapSection } from "../components/sections/MasterMapSection";
import { ProblemSection } from "../components/sections/ProblemSection";
import { BeforeAfterSection } from "../components/sections/BeforeAfterSection";
import { ProofSection } from "../components/sections/ProofSection";
import { ForYouSection } from "../components/sections/ForYouSection";
import { VolumesSection } from "../components/sections/VolumesSection";
import { ToolkitSection } from "../components/sections/ToolkitSection";
import { BonusesSection } from "../components/sections/BonusesSection";
import { OfferSection } from "../components/sections/OfferSection";
import { GuaranteeSection } from "../components/sections/GuaranteeSection";
import { LookForSection } from "../components/sections/LookForSection";
import { CreatorSection } from "../components/sections/CreatorSection";
import { FaqSection } from "../components/sections/FaqSection";
import { FinalSection } from "../components/sections/FinalSection";
import { SiteFooter } from "../components/sections/SiteFooter";
import { FloatingCta } from "../components/FloatingCta";
import { PurchasePopup } from "../components/PurchasePopup";
type SalesPageProps = {
  showPurchasePopup: boolean;
};
export function SalesPage({
  showPurchasePopup
}: SalesPageProps) {
  return <div className="w-full min-h-screen bg-cream font-sans text-ink" data-id="element-339" data-mp="3tghxfejnx8h7">
      <HeroSection data-id="element-340" data-mp="3okstkz0m15f3" />
      <main data-id="element-341" data-mp="3ohet5wbib6aa">
        <StorySection data-id="element-342" data-mp="3oholvrnxrrjo" />
        <MasterMapSection data-id="element-343" data-mp="3jjvg2zqjozjx" />
        <ProblemSection data-id="element-344" data-mp="3jjd7d3mp4sv4" />
        <BeforeAfterSection data-id="element-345" data-mp="3jilgg641njb6" />
        <ProofSection data-id="element-346" data-mp="3fite4b58u9e9" />
        <ForYouSection data-id="element-347" data-mp="3fjkzkt54mqqt" />
        <VolumesSection data-id="element-348" data-mp="3fi1kv6z4cnr5" />
        <ToolkitSection data-id="element-349" data-mp="3fkw10mb3nmer" />
        <BonusesSection data-id="element-350" data-mp="284zrom23jjq6" />
        <OfferSection data-id="element-351" data-mp="285htdy7j2q5h" />
        <GuaranteeSection data-id="element-352" data-mp="286sxy08ss1xn" />
        <LookForSection data-id="element-353" data-mp="282wrxab56c89" />
        <CreatorSection data-id="element-354" data-mp="2434r5jrzpadg" />
        <FaqSection data-id="element-355" data-mp="242l63u71m5v7" />
        <FinalSection data-id="element-356" data-mp="242cue5mnp6ll" />
      </main>
      <SiteFooter data-id="element-357" data-mp="25ktls8tx9j6z" />
      <FloatingCta data-id="element-358" data-mp="25ka1ilgsuips" />
      {showPurchasePopup && <PurchasePopup data-id="element-359" data-mp="25ll78qtt20jj" />}
    </div>;
}